export const paytypeDiscount = {
  // 390: [
  //   {
  //     f_pay_type: 'waffo',
  //     pay_type: 'CREDITCARD-CC_ELO',
  //     discount: '10.38%'
  //   },
  //   {
  //     f_pay_type: 'waffo',
  //     pay_type: 'CREDITCARD-CC_HIPERCARD',
  //     discount: '10.38%'
  //   },
  //   {
  //     f_pay_type: 'waffo',
  //     pay_type: 'DEBITCARD-DC_ELO',
  //     discount: '10.38%'
  //   },
  //   {
  //     f_pay_type: 'waffo',
  //     pay_type: 'EWALLET-MERCADOPAGO',
  //     discount: '10.38%'
  //   },
  //   {
  //     f_pay_type: 'waffo',
  //     pay_type: 'EWALLET-PICPAY',
  //     discount: '10.38%'
  //   },
  //   {
  //     f_pay_type: 'waffo',
  //     pay_type: 'EWALLET-PIX',
  //     discount: '10.38%'
  //   },
  //   {
  //     f_pay_type: 'waffo',
  //     pay_type: 'OTC-BOLETO',
  //     discount: '10.38%'
  //   },
  //   {
  //     f_pay_type: 'payer_max',
  //     pay_type: 'BR-WALLET-PIX',
  //     discount: '10.38%'
  //   },
  //   {
  //     f_pay_type: 'payer_max',
  //     pay_type: 'BR-WALLET-MERCADOPAGO',
  //     discount: '10.38%'
  //   },
  //   {
  //     f_pay_type: 'payer_max',
  //     pay_type: 'BR-WALLET-NUPAY',
  //     discount: '10.38%'
  //   },
  //   {
  //     f_pay_type: 'payer_max',
  //     pay_type: 'BR-BANK_TRANSFER',
  //     discount: '10.38%'
  //   },
  //   {
  //     f_pay_type: 'payer_max',
  //     pay_type: 'BR-OTC-BOLETO',
  //     discount: '10.38%'
  //   },
  //   {
  //     f_pay_type: 'payer_max',
  //     pay_type: 'BR-OTC-BOLETO_FAST',
  //     discount: '10.38%'
  //   }
  // ]
};
